// JournalListItem.js - Listrad för journal i vänsterpanelen

import React from 'react';
import './JournalListItem.css';

const JournalListItem = ({ journal, isSelected, isReference = false, onClick, onShiftClick, onShowBeside }) => {
  // Formatera datum
  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleDateString('sv-SE');
  };

  // Formatera tid
  const formatTime = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleTimeString('sv-SE', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handleClick = (e) => {
    if (e.shiftKey && onShiftClick) {
      onShiftClick(journal.entry_id);
    } else {
      onClick(journal.entry_id);
    }
  };

  return (
    <div
      className={`journal-list-item ${isSelected ? 'selected' : ''} ${isReference ? 'reference' : ''}`}
      onClick={handleClick}
    >
      {/* Visa posten skrivskyddad bredvid den öppna (Spår J2) */}
      {onShowBeside && !isReference && (
        <button
          type="button"
          className="journal-item-beside-btn"
          onClick={(e) => { e.stopPropagation(); onShowBeside(journal.entry_id); }}
          title="Visa bredvid"
        >
          <i className="fas fa-columns"></i> Visa bredvid
        </button>
      )}
      <div className="journal-item-icon">
        <i className="fas fa-file-medical"></i>
      </div>
      <div className="journal-item-content">
        <div className="journal-item-datetime">
          <span className="journal-item-date">{formatDate(journal.created_at)}</span>
          <span className="journal-item-time">{formatTime(journal.created_at)}</span>
        </div>
        <div className="journal-item-template">
          {journal.display_name || journal.template_name || 'Utan mall'}
        </div>
        <div className="journal-item-footer">
          <span className="journal-item-user">{journal.user_name}</span>
          <span className={`journal-item-status status-${journal.status}`}>
            {journal.status === 'signed' ? (
              <><i className="fas fa-check"></i> Signerad</>
            ) : (
              <><i className="fas fa-circle"></i> Utkast</>
            )}
          </span>
        </div>
      </div>
    </div>
  );
};

export default JournalListItem;
